
import Core from 'hvx/modules/CoreModule';
import { h } from 'snabbdom';
import { itemView } from './components';


/**
   * 
   * @param {Notification} notification 
   * @returns 
   */
// TODO: this should be it's own class
const radial_progress = (notification, onTimeoutClick) => 
  h('div.countdown',{ on: { click: () => {
    onTimeoutClick(notification);
  }
  } }, [
    h('svg',[
      h('circle.circle-bg' , { attrs: 
        { cx: 8,
          cy: 8,
          r: 7 }}),
      h('circle.circle-progress' , { attrs: 
        { cx: 8,
          cy: 8,
          r: 7 },
      style: { '--duration': `${notification.time / 1000}` } })
    ])
  ]);  
export default class Popup {

  /**
   * 
  * @param {import('./store').NotificationStoreItem} notification
  * @returns vnode
   */
  static render(notification, options, onTimeoutClick)  {
    return h('div.notify-popup-item', {
      dataset: {
        id: notification.id
      },
      style: {
        // TODO: add animation
        // remove: {
        //   transition: 'opacity 1s',
        //   opacity: '0' ,
        // }
      },
    }, [
      notification.time > 0 ? 
        radial_progress(notification, onTimeoutClick )
      // h('div.round-time-bar', {
      //   style: {
      //     '--duration': `${notification.time / 1000}`
      //   }
      // }, [h('div')]) 
        : '',
  
      h('div.notify-popup-close.bi.bi-x-circle'),
      itemView(notification, {
        ...options
      })
    ]);
  
  }
}

